import Card from "./card";

const cardArr: Array<Card> = [
  {
    title: 'Intro to Web Development',
    description: 'Learn more about web development languages (HTML & CSS) and create your first website!',
    time: 'Fri Oct 8th, 9pm - 10pm CST',
    difficulty: 0,
    level: 'Beginner friendly! No experience necessary :)',
    codeLink: 'N/A',
    slidesLink: 'N/A',
    dependency: 'Nothing!',
    dependencyLink: "",
    visible: true,
    vidLink: 'https://www.twitch.tv/vandyhacks2',
  },
  {
    title: 'Web Scraping',
    description: 'Learn how to scrape websites of all shapes and sizes with BeautifulSoup and Python, as well as automate these processes with Selenium WebDriver!',
    time: 'Fri Oct 8th, 10pm - 11pm CST',
    difficulty: 1,
    level: 'Intermediate (Basic Web Dev Knowledge Recommended!)',
    codeLink: 'N/A',
    slidesLink: 'N/A',
    dependency: 'Python',
    dependencyLink: "",
    visible: true,
    vidLink: 'https://www.twitch.tv/vandyhacks',
  },
  {
    title: 'GraphQL',
    description: 'Learn about the powerful capabilities of GraphQL, the easier way to make APIs!',
    time: 'Fri Oct 8th, 11pm - midnight CST',
    difficulty: 1,
    level: 'Intermediate',
    codeLink: 'N/A',
    slidesLink: 'N/A',
    dependency: 'Nothing!',
    dependencyLink: "",
    visible: true,
    vidLink: 'https://www.twitch.tv/vandyhacks',
  },
  {
    title: 'Deep Learning and Image Classification',
    description: 'Learn how to classify images using deep learning and Python!',
    time: 'Fri Oct 8th, 10pm - 11pm CST',
    difficulty: 1,
    level: 'Intermediate',
    codeLink: 'N/A',
    slidesLink: 'N/A',
    dependency: 'Google Colab',
    dependencyLink: "",
    visible: true,
    vidLink: 'https://www.twitch.tv/vandyhacks2',
  },
  {
    title: 'Nix',
    description: 'Never hear "...but it works on my machine?" ever again — Learn more about Nix with us!',
    time: 'Fri Oct 8th, 9pm - 10pm CST',
    difficulty: 2,
    level: 'Advanced',
    codeLink: 'N/A',
    slidesLink: 'N/A',
    dependency: 'Nothing!',
    dependencyLink: "",
    visible: true,
    vidLink: 'https://www.twitch.tv/vandyhacks',
  },
  {
    title: 'Drone Strikes and Disinformation: What Your CS & Ethics Class Didn’t Teach You',
    description: 'CS can be a powerful tool for both good and evil — and now more than ever, it’s important to know the difference. Join us for a discussion about social media companies, artificial intelligence, and how to make tough decisions in a tech-driven world.!',
    time: 'Sat Oct 9th, 10am - 11am',
    difficulty: 0,
    level: 'All levels of hackers welcome!',
    codeLink: 'N/A',
    slidesLink: 'N/A',
    dependency: 'Nothing!',
    dependencyLink: "",
    visible: true,
    vidLink: 'https://www.twitch.tv/vandyhacks',
  }, 
  { 
    title: 'How to Solve Famous Problems',
    description: 'There are quite a few problems that illustrate key challenges when designing algorithms for synchronization and computer networking! Join us in our discussion of how to solve (or prove that we can’t solve) famous problems in CS!',
    time: 'Sat Oct 9th, 11am - noon',
    difficulty: 0,
    level: 'All levels of hackers welcome!',
    codeLink: 'N/A',
    slidesLink: 'N/A',
    dependency: 'Nothing!',
    dependencyLink: "",
    visible: true,
    vidLink: 'https://www.twitch.tv/vandyhacks',
  }
];

export default cardArr;
